import React,{useState,useEffect} from "react";
import {toast} from "react-toastify";
/* import {GENURL} from "../config/config.jsx"; */
import { CurrencySymbol } from "../components/csymbol.jsx";
import { FaSearch } from "react-icons/fa";
import Hero from "../components/Hero.jsx";
import RegionData from "../data/RegionData.jsx";
import WagesData from "../data/WagesData.jsx";
import { useNavigate } from "react-router-dom";

const Countries = () => {  
  const navigate = useNavigate();
  const [region,setRegion] = useState([]);
  const [wages,setWages] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedIndex, setExpandedIndex] = useState(null); 
  const [selectedRegion, setSelectedRegion] = useState(null);
  const ITEMS_PER_PAGE = 6;

  const loadRegionData = () => {
    try {
      if (RegionData.actionMsg === 1) {
        setRegion(RegionData.regionlist);
      } else {
        toast.error(`${RegionData.Message}`, { duration: 1000 });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, { duration: 1000 });
    }
  };
  const getwages = () => {
    try {
      const res = WagesData; // Use static data
      if (res.actionMsg === 1) {
        setWages(res.wagesdata);
      } else {
        toast.error(`${res.Message}`, { duration: 1000 });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, { duration: 1000 });
    }
  };
  useEffect(()=>{
    loadRegionData();
    getwages();
    /* async function getregion(){
      try{
        let api = `${GENURL}region`
        let postData = {'method':'get','headers':{'content-type':'application/json'}}
        let response = await fetch(api,postData)
        let res = await response.json();
        if(res.actionMsg === 1){
          setRegion(res.regionlist)
        }
        else{
          toast.error(''+res.Message+'',{duration:1000})
        }
      }
      catch(error){
        toast.error(''+error.message+'',{duration:1000})
      }
    } */

   /*  async function getwages(){
      try{
        let api = `${GENURL}wages`
        let postData = {'method':'get','headers':{'content-type':'application/json'}}
        let response = await fetch(api,postData)
        let res = await response.json();
        if(res.actionMsg === 1){
          setWages(res.wagesdata)
        }
        else{
          toast.error(''+res.Message+'',{duration:1000})
        }
      }
      catch(error){
        toast.error(''+error.message+'',{duration:1000})
      }
    } */

   /*  getregion()
    getwages() */

  },[])

  // Filter the country data based on the search term
  const filtered = wages.filter((data) => {
    const matchesSearch = data.country_name.toLowerCase().includes(searchTerm.toLowerCase()) || data.region_name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRegion = selectedRegion ? data.region_id === selectedRegion : true; // Filter by selected region
    return matchesSearch && matchesRegion;
  });

  const handleWages = (region_id) => {
    if (region_id === 'showall') {
      setSelectedRegion(null); 
    } else {
      setSelectedRegion(region_id);
    }
    setCurrentPage(1); 
  };

  // Pagination logic
  const indexOfLast = currentPage * ITEMS_PER_PAGE;
  const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };


  const toggleDescription = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const getCurrencyLabel = (value) => {
    let found = CurrencySymbol.find(item => item.value === value);
    return found ? found.label : 'Label not found';
  };

  const handleImageClick = (country) => {
    const formattedCountry = country.title.toLowerCase().replace(/\s+/g, '-'); // Replace spaces with hyphens
    navigate(`/country/${formattedCountry}`,{ state: country });
    
  }
  return (
    <>
      <Hero
      title="Where Is Your Talent Strategy Expanding?"
      description="We support your global hiring efforts with expertise and compliance in over 40+ countries."
      buttonText="Get EOR Guide"
      customClass="countryBanner"
      imageSrc="images/country.webp"
      squareColor="countrysquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
      <>
      <div className="cwrapper">
        <div className="container">
          <div className="cheader_section">
            <div className="cheader_data">
              <div className="cheader_list">
                <ul>
                  <li>
                    <div className="cheader_content" onClick={() => handleWages('showall')}>
                    <div className="cheader_img">
                          <img src="/images/viewall.png" alt="viewall" className="img-fluid removeStyle"/>
                        </div>
                      <div className="cheader_title">
                        <span>View all</span>
                      </div>
                    </div>
                  </li>
                {
                  region?.map((item,index)=>(
                    <li key={index}>
                      <div className="cheader_content" onClick={() => handleWages(item.id)}>
                        <div className="cheader_img">
                          <img src={item.image} alt={item.name} className="img-fluid" />
                        </div>
                        <div className="cheader_title">
                          <span>{item.name}</span>
                        </div>
                      </div>
                    </li>
                  ))
                }
                </ul>
              </div>
            </div>
          </div>
          <div className="body_tsection">
            <div className="body_tdata">
              <div className="body_scontent">
                <div className="row ps-2 mb-4 mt-2">
                  <div className="col-lg-3">&nbsp;</div>
                  <div className="col-lg-6">
                    <div className="input_section">
                      <div className="form_ricon_group" style={{alignItems:'center'}}>
                        <input
                          type="text"
                          placeholder="Search by country or region"
                          onChange={handleSearchChange}
                        />
                        <span><FaSearch /></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="body_tcontent">
                <div className="row g-3">
                  {
                    currentData.length > 0 ?
                      currentData.map((item, index) => (
                        <div className="col-lg-4" key={index}>
                          <div className="hcard_section">
                            <div className="hcard_image">
                              <img src={item.imageUrl} alt={item.title} className="img-fluid" />
                            </div>
                            <div className="hcard_bsection">
                              <div className="hcard_tsection">
                                <p>{item.title}</p>
                                <img src="/images/view-more.svg" alt="viewall" className="img-fluid removeStyle" onClick={() => handleImageClick(item)}/>
                              </div>
                              <div className="hcard_subsection">
                                <span><u>Region</u><br/>{item.region_name}</span>
                                <span><u>Currency</u><br/>{getCurrencyLabel(item.currency)}</span>
                                <span><u>Country</u><br/>{item.country_name}</span>
                              </div>
                              <div className="hcard_scontent">
                                <div className="hcard_sdata">
                                  {item.description.length > 300 ? (
                                    <>
                                      <div className="htext"
                                        dangerouslySetInnerHTML={{
                                          __html: expandedIndex === index ? item.description : item.description.substring(0, 300) + '...',
                                        }}
                                      />
                                      <button
                                        onClick={() => toggleDescription(index)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {expandedIndex === index ? <>Show Less &#9650;  </> : <>Show More &#9660;</>}
                                      </button>
                                    </>
                                  ) : (
                                    <div className="htext"
                                      dangerouslySetInnerHTML={{
                                        __html: item.description,
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )) :
                      <p className="msgtext">No Countries was found.</p>
                  }
                </div>
              </div>
              <div className="body_psection">
                <div className="pagination">
                  <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>First</button>
                  <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Prev</button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    Next
                  </button>
                  <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Last</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    </>
  );
};

export default Countries;
